import { Box, BoxProps } from "@mui/material";
import * as React from "react";

interface ActivityDetailsProps extends BoxProps {
  children: React.ReactNode;
  // variant?: "success" | "warning" | "error" | "info" | "primary" | "default";
}

// const BorderColor: any = {
//   success: "success.main",
//   warning: "warning.main",
//   error: "error.main",
//   info: "info.main",
//   primary: "primary.text",
//   default: "backgroundAlpha.main",
// };

const ActivityDetails: React.FC<ActivityDetailsProps> = (props) => {
  const { children, ...otherProps } = props;
  return (
    <Box
      sx={{
        marginLeft: "15px",
        marginTop: "8px",
        paddingLeft: "27px",
        borderLeft: "2px solid",
        borderColor: "backgroundAlpha.main",
      }}
      {...otherProps}
    >
      {children}
    </Box>
  );
};

export default ActivityDetails;
